/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ContentTransactionLogDtoPaginatedItemsViewModel } from '../model/contentTransactionLogDtoPaginatedItemsViewModel';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContentTransactionLogsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param contentId 
     * @param channel 
     * @param dateFrom 
     * @param dateTo 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentTransactionLogsGetContentTransactionsLogsByContentIdDateRangeAndChannelGet(contentId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ContentTransactionLogDtoPaginatedItemsViewModel>;
    public apiContentTransactionLogsGetContentTransactionsLogsByContentIdDateRangeAndChannelGet(contentId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentTransactionLogDtoPaginatedItemsViewModel>>;
    public apiContentTransactionLogsGetContentTransactionsLogsByContentIdDateRangeAndChannelGet(contentId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentTransactionLogDtoPaginatedItemsViewModel>>;
    public apiContentTransactionLogsGetContentTransactionsLogsByContentIdDateRangeAndChannelGet(contentId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentId !== undefined && contentId !== null) {
            queryParameters = queryParameters.set('contentId', <any>contentId);
        }
        if (channel !== undefined && channel !== null) {
            queryParameters = queryParameters.set('channel', <any>channel);
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('dateFrom', <any>dateFrom.toISOString());
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('dateTo', <any>dateTo.toISOString());
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentTransactionLogDtoPaginatedItemsViewModel>('get',`${this.basePath}/api/ContentTransactionLogs/GetContentTransactionsLogsByContentIdDateRangeAndChannel`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
